import React, { Fragment } from 'react';
import T from 'prop-types';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash-es';

import Skeleton from '../../../Skeleton';
import ErrorStateWithReload from '../../../ErrorStateWithReload';
import PushToSalesforceButton from './PushToSalesforceButton';
import { permissionsSelector } from '../../selectors';

const PubHeader = ({
  publisher,
  settings,
  salesforceAccountUrl,
  isLoading,
  onSalesforceButtonClick,
}) => {
  const permissions = useSelector(permissionsSelector);

  return settings.error ? (
    <ErrorStateWithReload />
  ) : (
    <Fragment>
      <div className="prospects-sidebar__header">
        <div className="prospects-sidebar__header-max">
          <div className="prospects-sidebar__header-max-text">
            <div className="prospects-sidebar__header-max-text-head h3 text-truncate">
              {settings.pending ? <Skeleton height={24} width={200} /> : publisher.name}
            </div>
            {permissions.allowApptopiaToSalesforceIntegration && !isEmpty(publisher) && (
              <div className="prospects-sidebar__header-max-btn">
                <PushToSalesforceButton
                  permissions={permissions}
                  salesforceAccountUrl={salesforceAccountUrl}
                  isLoading={isLoading}
                  handleClick={onSalesforceButtonClick}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="prospects-sidebar__header-description paragraph-md">
        {settings.pending ? <Skeleton height={56} /> : publisher.short_description}
      </div>
    </Fragment>
  );
};

PubHeader.propTypes = {
  publisher: T.object.isRequired,
  settings: T.object.isRequired,
  salesforceAccountUrl: T.oneOfType([T.string, T.bool]),
  isLoading: T.bool,
  onSalesforceButtonClick: T.func.isRequired,
};

export default PubHeader;
